import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoadingSpinnerStore = defineStore('loadingSpinner', () => {
  const loadingSpinner = ref<boolean>(false);
  const localLoadingSpinner = ref<boolean>(false);

  const showLoadingSpinner = () => {
    loadingSpinner.value = true;
  };

  const hideLoadingSpinner = () => {
    loadingSpinner.value = false;
  };

  const showLocalLoadingSpinner = () => {
    localLoadingSpinner.value = true;
  };

  const hideLocalLoadingSpinner = () => {
    localLoadingSpinner.value = false;
  };

  return {
    loadingSpinner,
    localLoadingSpinner,
    showLoadingSpinner,
    hideLoadingSpinner,
    showLocalLoadingSpinner,
    hideLocalLoadingSpinner,
  };
});
